import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/pessoajuridicatipos?include=tipopessoa`, options).then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };
  
  return axios
    .get(`${url}/pessoajuridicatipos/${id}?include=tipopessoa`, options)
    .then(response => {
      let pessoajuridicatipo = jsona.deserialize(response.data);
      delete pessoajuridicatipo.links;
      return pessoajuridicatipo;
    });
}

function add(pessoajuridicatipo) {
  const payload = jsona.serialize({
    stuff: pessoajuridicatipo,
    includeNames: ["categories"]
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  
  //.post(`${url}/pessoajuridicatipos?include=tipopessoa`, payload, options)
  return axios
    .post(`${url}/pessoajuridicatipos?include=tipopessoa`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(pessoajuridicatipo) {
  const payload = jsona.serialize({
    stuff: pessoajuridicatipo,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  
  return axios
    .patch(`${url}/pessoajuridicatipos/${pessoajuridicatipo.id}?include=tipopessoa`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.delete(`${url}/pessoajuridicatipos/${id}`, options);
}
function downloadPDF(tipo, arquivo) {
  return axios.get(`${url}/downloads/${tipo}/${arquivo}.pdf`, { responseType: 'blob' }).then((response) => {
    return response.data;
  });
}
/*
function upload(pessoajuridicatipo, image) {
  const bodyFormData = new FormData();
  bodyFormData.append("attachment", image);

  return axios
    .post(`${url}/uploads/pessoajuridicatipos/${pessoajuridicatipo.id}/image`, bodyFormData)
    .then(response => {
      return response.data.url;
    });
}
export default {
  list,
  get,
  add,
  update,
  destroy,
  upload
};
*/
export default {
  list,
  get,
  add,
  update,
  destroy,
  downloadPDF
};